import { endOfDay, format, startOfDay } from 'date-fns';
import { Moment } from 'moment';

type InvoiceDate = Date | Moment | string;

const formatInvoiceDateParam = (
  date: InvoiceDate | null | undefined,
  isEndDate: boolean
): string | undefined => {
  if (!date) return undefined;
  if (typeof date !== 'string' && 'format' in date) {
    return date
      .clone()
      [isEndDate ? 'endOf' : 'startOf']('day')
      .format();
  }
  const parsedDate =
    typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)
      ? new Date(`${date}T00:00:00`)
      : new Date(date);
  const dateAtBoundary = isEndDate
    ? endOfDay(parsedDate)
    : startOfDay(parsedDate);
  return format(dateAtBoundary, "yyyy-MM-dd'T'HH:mm:ss.SSSxxx");
};

export default formatInvoiceDateParam;
